import React from "react";
import {
  Row,
  Col,
  Form,
  Label,
  Input,
  Modal,
  ModalHeader,
  ModalBody,
  FormFeedback,
} from "reactstrap";

const ChecklistAnswerModal = ({
  show,
  onCloseClick,
  validation,
  selectedQuestion,
}) => {
  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalHeader style={{ display: "flex", justifyContent: "center" }}>
        {selectedQuestion?.question || ""}
      </ModalHeader>
      <Form
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}
      >
        <ModalBody className="py-5 px-4">
          <Row>
            <Col xs={12}>
              <div className="mb-3">
                {selectedQuestion?.data_type === "textbox" ? (
                  <Input
                    name="answer"
                    type="text"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.answer || ""}
                    invalid={
                      validation.touched.answer && validation.errors.answer
                        ? true
                        : false
                    }
                  />
                ) : selectedQuestion?.data_type === "decimal" ? (
                  <Input
                    name="answer"
                    type="number"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.answer || 0}
                    invalid={
                      validation.touched.answer && validation.errors.answer
                        ? true
                        : false
                    }
                  />
                ) : (
                  <Input
                    type="select"
                    name="answer"
                    className="form-select"
                    multiple={false}
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.answer || "0"}
                    invalid={
                      validation.touched.answer && validation.errors.answer
                        ? true
                        : false
                    }
                  >
                    <option value={""}>Select your answer</option>
                    {selectedQuestion?.site_checklist_options.map(
                      (item, index) => (
                        <option key={index} value={item.option_value}>
                          {item.option_label}
                        </option>
                      )
                    )}
                  </Input>
                )}

                {validation.touched.answer && validation.errors.answer ? (
                  <FormFeedback type="invalid">
                    {validation.errors.answer}
                  </FormFeedback>
                ) : null}
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <div className="text-center mt-3">
                <button
                  type="button"
                  className="modalBackButton"
                  onClick={onCloseClick}
                >
                  Cancel
                </button>
                <button type="submit" className="modalSaveButton">
                  Save
                </button>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Form>
    </Modal>
  );
};

export default ChecklistAnswerModal;
